import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { Heart, Coffee, Diamond, GraduationCap } from "lucide-react";

const INTERIOR_IMG =
  "https://customer-assets.emergentagent.com/job_smile-transformation-10/artifacts/fq8bizzv_WhatsApp%20Image%202026-05-25%20at%208.37.41%20PM%20%281%29.jpeg";

const ICONS = [Heart, Coffee, Diamond, GraduationCap];

export const TrustSection = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="trust-section"
      className="bg-white py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 reveal">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] bg-[#F9F8F6]">
              <img
                src={INTERIOR_IMG}
                alt="Multident interior premium"
                className="w-full h-full object-cover"
              />
              <div className="absolute left-6 bottom-6 right-6 bg-white/80 backdrop-blur-xl border border-white/40 rounded-2xl px-6 py-5">
                <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-2">
                  Multident · Experience
                </p>
                <p className="font-display text-lg md:text-xl text-[#1A1A1A] leading-snug">
                  “Tu sonrisa merece algo extraordinario.”
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <p className="overline mb-6 reveal">— {t.trust.overline}</p>
            <h2 className="reveal font-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A1A1A]">
              {t.trust.title}{" "}
              <span className="italic text-[#D4AF37]">
                {t.trust.title_accent}
              </span>
            </h2>
            <p className="reveal mt-6 text-[#666666] text-base md:text-lg leading-relaxed max-w-lg">
              {t.trust.sub}
            </p>

            <div className="mt-12 grid sm:grid-cols-3 gap-px bg-[#E5E5E5] border border-[#E5E5E5] rounded-3xl overflow-hidden">
              {t.trust.pillars.map((p, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <div
                    key={i}
                    data-testid={`trust-pillar-${i}`}
                    className="reveal bg-[#F9F8F6] p-6 md:p-8"
                    style={{ transitionDelay: `${i * 80}ms` }}
                  >
                    <Icon
                      size={22}
                      strokeWidth={1.4}
                      className="text-[#D4AF37] mb-4"
                    />
                    <h3 className="font-display text-base md:text-lg text-[#1A1A1A] tracking-tight mb-2">
                      {p.t}
                    </h3>
                    <p className="text-xs md:text-sm text-[#666666] leading-relaxed">
                      {p.d}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
